var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldUserTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91 21.5c0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5s-9.09 3.36-9.09 7.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88 3.1A4.956 4.956 0 0 0 7 7c0 .94.26 1.82.73 2.57A4.949 4.949 0 0 0 12 12c1.26 0 2.41-.46 3.29-1.25.39-.33.73-.73.99-1.18.46-.75.72-1.63.72-2.57 0-2.76-2.24-5-5-5-1.18 0-2.26.41-3.12 1.1zm3.04 5.82c-.18.17-.41.25-.64.25a.93.93 0 0 1-.66-.27L9.39 7.66a.936.936 0 0 1 0-1.33c.37-.37.96-.37 1.33 0l.59.59 2.01-1.85c.38-.35.97-.33 1.32.05.35.39.33.99-.05 1.34l-2.67 2.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldUserTick);
export default __webpack_public_path__ + "static/media/vuesax-bold-user-tick.4657d52e2193d665cad0a4519944843d.svg";
export { ForwardRef as ReactComponent };